var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticStyle:{"height":"40px"},attrs:{"color":"info","disabled":_vm.disabled},on:{"click":_vm.exportPDF}},[_c('v-icon',[_vm._v("mdi-printer")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }